<template>
  <div class="finance">
    <finance-header />
    <tab-bar />
    <router-view />
  </div>
</template>

<script>
import Header from "../components/finance/Header";
import TabBar from "../components/finance/TabBar";

export default {
  components: {
    "finance-header": Header,
    "tab-bar": TabBar
  }
};
</script>

<style scoped></style>
